/* eslint-disable max-len */
import React, { useState, useRef, useEffect } from 'react';
import $ from 'jquery';
import Tooltip from '@mui/material/Tooltip';
import { executeArgoDefault } from '../shared/constantVariable';
import { Feed, ProductOut, WasteOut, MixSplit, Pump, RO, RO_Pump, Chemical_Dosing, CF_new, CLRO, EDI, stripperImage, TC, PW, ERD, grid_view, grid_view_pressed, single_view_grid, single_view_grid_pressed } from '../shared/assets/images';
import '../styles/sidebar.scss';

export default (props) => { // eslint-disable-next-line
  let { clroAccess, NFFeedAccess, ArgoAccess, elements, ROHPFeedBleedAccess, ROFeedBleedAccess } = props;
  const [doubleGrid, setdoubleGrid] = useState(false);
  const [singleGrid, setsingleGrid] = useState(true);
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };
  const [widthExpand, setWidthExpand] = useState(70);
  const feedIconBlock = useRef();
  function increaseWidth() {
    setdoubleGrid(true);
    setsingleGrid(false);
    setWidthExpand(155);
    $('.feed-icon-block').css('display', 'block');
    $('.canvas-wrapper, .wrapper-sidebar').addClass('expended');
    document.querySelector('.feed-icon-block').scrollTop = 0;
  }
  function decreaseWidth() {
    setdoubleGrid(false);
    setsingleGrid(true);
    setWidthExpand(80);
    $('.feed-icon-block').css('display', '');
    $('.canvas-wrapper, .wrapper-sidebar').removeClass('expended');
  }
  const filterIconsByAccess = (icons, access) => {
    if (!access) {
      // return icons.filter(item => item.title !== 'CLRO');
      return icons.filter(item => item.title !== 'DSSRO');
    }
    return icons;
  };
  useEffect(() => {
    increaseWidth();
  }, []);
  const renderIconGroups = (iconGroups) => iconGroups.map((group, groupIndex) => (
    <div key={`group-${groupIndex}`} className="icon-group">
      {group.map((icon, iconIndex) => {
        const isFeedAO = icon.title === 'FeedAO';
        const hasGroupRAAFeed = elements.length > 0 && elements.some(el => el.id.replace(/[\d_]+/g, '') === 'groupRAAFeed');
        localStorage.setItem('StandAloneARGO', hasGroupRAAFeed);
        // @kranthi: Disable icon if there's already a RAAFeed group OR if there are existing elements and this is FeedAO
        const shouldDisable = hasGroupRAAFeed || (elements.length > 0 && isFeedAO);
        // const shouldDisable = hasGroupRAAFeed || !isFeedAO ? FeedAA.length > 0 : elements.length > 0 && !hasGroupRAAFeed;

        return (
          <Tooltip key={`icon-${iconIndex}`} title={icon.title} placement="right" arrow>
            <div
              className="dndnode feed-icon"
              style={{
                borderRadius: shouldDisable ? '5px' : '',
                background: shouldDisable ? '#C8C8DA' : '',
                cursor: shouldDisable ? 'not-allowed' : 'grab',
              }}
              onDragStart={
                shouldDisable
                  ? undefined
                  : (event) => onDragStart(event, icon.onDragStart)
              }
              draggable={!shouldDisable}
            >
              <span className="center-flowsheet">
                <label className="icon-name sansW4SeLig" style={{ cursor: shouldDisable ? 'not-allowed' : 'grab' }}>{icon.text}</label>
                <div className="tooltip-content">
                  <input className="nodrag feed-image" type="image" style={{ cursor: shouldDisable ? 'not-allowed' : 'grab' }} src={icon.src} />
                </div>
              </span>
            </div>
          </Tooltip>
        );
      })}
    </div>
  ));
  const sidemenuIconGroups = [
    // Group 1
    [
      { title: 'Feed', onDragStart: 'customnode_feed', src: Feed, 'text': 'Feed' },
      { title: 'CF', onDragStart: 'customnode_cartridge', src: CF_new, 'text': 'CF' },
      { title: 'Mixer/Splitter', onDragStart: 'customnode_mixsplit', src: MixSplit, 'text': 'Mixer/ Splitter' },
      { title: 'RO_HP', onDragStart: 'customnode_ROpump', src: RO_Pump, 'text': 'RO with Pump' },
      { title: 'EDI', onDragStart: 'customnode_edi', src: EDI, 'text': 'EDI' },
      { title: 'Product', onDragStart: 'customnode_product', src: ProductOut, 'text': 'Product' },
      { title: 'WasteOut', onDragStart: 'customnode_wasteout', src: WasteOut, 'text': 'Waste' },
    ],
    // Group 2
    [
      { title: 'Chemical Dosing', onDragStart: 'customnode_chemical_dosing', src: Chemical_Dosing, 'text': 'Chemical Dosing' },
      { title: 'STR', onDragStart: 'customnode_stripper', src: stripperImage, 'text': 'Gas Stripper' },
    ], // Group 3
    [
      { title: 'RO', onDragStart: 'customnode_productOut', src: RO, 'text': 'RO' },
      { title: 'Pump', onDragStart: 'customnode_pump', src: Pump, 'text': 'Pump' },
      { title: 'ROISO', onDragStart: 'customnode_WEX_PEX', src: ERD, 'text': 'RO with Isobaric ERD' },
      { title: 'ROPW', onDragStart: 'customnode_Pelton_Wheel', src: PW, 'text': 'RO with Pelton Wheel' },
      { title: 'ROTC', onDragStart: 'customnode_Turbo_Charger', src: TC, 'text': 'RO with Turbo Charger' },
    ],
    // Group 4
    [
      // { title: 'CLRO', onDragStart: 'customnode_CLROpump', src: CLRO, 'text': 'CLRO' },
      { title: 'DSSRO', onDragStart: 'customnode_CLROpump', src: CLRO, 'text': 'DSSRO' },
    ],
    // Group 5
    [
      { title: 'NF', onDragStart: 'customnode_productOut_NF', src: RO, 'text': 'NF' },
      { title: 'NFHP', onDragStart: 'customnode_NFpump', src: RO_Pump, 'text': 'NF with Pump' },
    ],
    // Group 6
    [
      { title: 'FeedAO', onDragStart: 'customnode_Feed_AO', src: RO_Pump, 'text': 'Argo Analyzer' }
    ],
    // Group 7
    [
      { title: 'Feed & Bleed RO', onDragStart: 'customnode_RO_Loop', src: RO_Pump, 'text': 'Feed & Bleed RO' },
      { title: 'Feed & Bleed RO with Pump', onDragStart: 'customnode_ROHP_Loop', src: RO_Pump, 'text': 'Feed & Bleed RO with Pump' }
    ],

  ];
  const SideMenuComponent = ({ clroAccess, sidemenuIconGroups, NFFeedAccess, ROHPFeedBleedAccess, ROFeedBleedAccess }) => {
    const accessibleIconGroups = sidemenuIconGroups.map(group =>
      filterIconsByAccess(group, clroAccess)
    );
    if (!NFFeedAccess) {
      accessibleIconGroups[4] = accessibleIconGroups[4].filter(icon => icon.title !== 'NF' && icon.title !== 'NFHP');
    };
    if (!ArgoAccess) {
      accessibleIconGroups[5] = accessibleIconGroups[5].filter(icon => icon.title !== 'FeedAO');
    }
    if (!ROHPFeedBleedAccess) {
      accessibleIconGroups[6] = accessibleIconGroups[6].filter(icon => icon.title !== 'Feed & Bleed RO with Pump');
    }
    if (!ROFeedBleedAccess) {
      accessibleIconGroups[6] = accessibleIconGroups[6].filter(icon => icon.title !== 'Feed & Bleed RO');
    }
    const renderedIcons = accessibleIconGroups.filter(group => group.length > 0);
    return renderIconGroups(renderedIcons);
  };
  return (
    <div className="wrapper-sidebar">
      <span className="material-icons" style={{ cursor: 'pointer' }}>
        <img src={singleGrid ? single_view_grid_pressed : single_view_grid} style={{ height: '18px', width: '18px', padding: '5px' }} className="center-img center-img-sigleNav" onClick={() => { decreaseWidth(); }} />
        <img src={doubleGrid ? grid_view_pressed : grid_view} style={{ height: '18px', width: '18px', padding: '5px' }} className="center-img center-img-doubleNav" onClick={() => { increaseWidth(); }} />
      </span>
      <div ref={feedIconBlock} className="feed-icon-block" style={{ width: widthExpand, marginTop: '10px' }}>
        {(() => {
          return SideMenuComponent({ clroAccess, sidemenuIconGroups, NFFeedAccess, ROHPFeedBleedAccess, ROFeedBleedAccess });
        })()}
      </div>
    </div>
  );
};